import {
    Alert,
    Button,
    Card,
    Col,
    Descriptions,
    Divider,
    Empty,
    Input,
    List,
    Modal,
    Row,
    Select,
    Space,
    Spin,
    Table,
    Tabs,
    Tag,
    Tooltip,
    Typography
} from "antd";
import { useState } from "react";
import { CardBody } from "react-bootstrap";
import {
    ArrowDownOutlined, ArrowUpOutlined, CreditCardOutlined, EditOutlined,
    FileTextOutlined, PlusOutlined, ReloadOutlined
} from "@ant-design/icons";
import { frenchDate } from "../../../../variables/functions";
import Encaissement from "../../components/Encaissements";
import { useNavigate } from "react-router-dom";
import ReglementRecoursModal from "../../components/modals/ReglementRecoursModal";
import AssignCheque from "../../components/AssignCheque";
import { displayNumbers } from "../../../../variables/numbersFunctions";
import RecoursCompagnies from "./sections/RecoursCompagnies";


const Recours = ({
    modalRecoursReevaluation,
    handleChange,
    loadingSinistre,
    items,
    name,
    inputRef,
    setValueSelected,
    setSelectedGaranties,
    modalEncaissement,
    sinistre,
    showFicheDemandeReglement,
    setProvisionGarantie,
    addProvisionFormFields,
    loadingSuspension,
    setModalEncaissement,
    setOpenEncaissement,
    provisionGaranties,
    valueSelected,
    handleSuspensionDossier,
    selectedGaranties,
    setMotifRevisionState,
    garanties,
    setGarantieState,
    modalSuspension,
    encaissements,
    addItem,
    onNameChange,
    setModalCloture,
    initEvaluation,
    loadingCloture,
    showQuittance,
    evaluation,
    setModalSuspension,
    removeProvisionFormFields,
    handleClotureDossier,
    showOrdreDepense,
    montant,
    recoursEvaluations,
    setEvaluation,
    editMode,
    modalCloture,
    setModalRecoursReevaluation,
    setIsRecours,
    editEvaluation,
    handleSubmit,
    onNouvelleReevaluation,
    setRefetch,
}) => {
    const [tabId, setTabId] = useState("1");
    const [modalAssignCheque, setModalAssignCheque] = useState(false)
    const [encaissement, setEncaissement] = useState("");

    const onTabsChange = (key) => {
        setTabId(key);
    };

    const navigate = useNavigate();

    // Piste RECOURS INDÉPENDANTE : plus de dérivation « évaluation × (100 − taux) » (supprimée).
    // Déjà encaissé = Σ des encaissements de recours (liste `encaissements`, déjà filtrée par le
    // parent sur decaissement.encaissement === true). Robuste même si sinistre.decaissements n'est
    // pas chargé (collection paresseuse).
    const totalEncaisse = () =>
        (encaissements || []).reduce((acc, d) => acc + (Number(d?.montantGlobal) || 0), 0);

    // Piste recours : PAS d'encaissement sans ÉVALUATION de recours. SAP recours = reste à encaisser
    // = evaluationRecours − Σ encaissements (repli local si le backend ne l'a pas encore calculé).
    const evaluationRecoursVal = Number(sinistre?.evaluationRecours) || 0;
    const hasEvalRecours = evaluationRecoursVal > 0;
    const sapRecoursVal = sinistre?.sapRecours != null
        ? Number(sinistre.sapRecours)
        : (evaluationRecoursVal - totalEncaisse());

    const [reglementModalOpen, setReglementModalOpen] = useState(false)
    // Recharge le dossier (donc la liste des encaissements) après une action. En V2, refetch ciblé ;
    // en V1 (setRefetch non fourni), repli sur un reload complet (comportement historique d'AssignCheque).
    const reloadDossier = () => {
        if (typeof setRefetch === "function") setRefetch((v) => !v);
        else window.location.reload();
    };
    const reglementControl = {
        open: reglementModalOpen,
        setOpen: setReglementModalOpen,
        onSaved: reloadDossier,
    }

    // Helpers d'affichage (montants tronqués au franc, cohérent avec le reste de l'appli).
    const ACCENT = "#242166";
    const fmt = (v) => `${displayNumbers(Math.trunc(Number(v) || 0))} FCFA`;
    const numeroSinistre = sinistre?.numeroSinistreM || sinistre?.numeroSinistreP || sinistre?.numSinistre || "-";
    const numeroPolice = sinistre?.contrat?.numeroPoliceM || sinistre?.contrat?.numeroPoliceP || "-";
    const assureNom = `${sinistre?.contrat?.souscripteur?.prenom || ""} ${sinistre?.contrat?.souscripteur?.nom || ""}`.trim() || "-";
    const tauxResp = parseFloat(sinistre?.tauxResponsabilite) || 0;

    // Tuile KPI compacte (titre gris + valeur colorée).
    const Kpi = ({ title, value, color = ACCENT, hint }) => (
        <Card size="small" bordered style={{ borderRadius: 10, background: "#fafaff", borderColor: "#2421661f", height: "100%" }}>
            <div style={{ fontSize: 12, color: "#8c8c8c", textTransform: "uppercase", letterSpacing: 0.3 }}>{title}</div>
            <div style={{ fontSize: 20, fontWeight: 700, color, marginTop: 4 }}>{value}</div>
            {hint ? <div style={{ fontSize: 11, color: "#bfbfbf", marginTop: 2 }}>{hint}</div> : null}
        </Card>
    );

    const resumeTab = (
        <div style={{ padding: 4 }}>
            <Row gutter={[16, 16]}>
                <Col xs={24} sm={8}>
                    <Kpi title="Évaluation recours" value={fmt(sinistre?.evaluationRecours)}
                        hint="Provision de recours courante" />
                </Col>
                <Col xs={24} sm={8}>
                    <Kpi title="Déjà encaissé" value={fmt(totalEncaisse())} color="#389e0d" />
                </Col>
                <Col xs={24} sm={8}>
                    {/* SAP recours = reste à encaisser (calculé par le backend : évaluation recours
                        − Σ encaissements). Repli sur le calcul local si le champ n'est pas encore là. */}
                    <Kpi title="Reste à encaisser (SAP recours)"
                        value={fmt(sinistre?.sapRecours != null ? sinistre.sapRecours : ((Number(sinistre?.evaluationRecours) || 0) - totalEncaisse()))}
                        color="#d46b08" />
                </Col>
            </Row>

            <div style={{ marginTop: 16 }}>
                <RecoursCompagnies sinistre={sinistre} />
            </div>

            <Card size="small" bordered style={{ marginTop: 16, borderRadius: 10, borderColor: "#2421661f" }}
                title={<span style={{ color: ACCENT }}><FileTextOutlined /> Sinistre N° {numeroSinistre}</span>}>
                <Descriptions column={{ xs: 1, sm: 2, lg: 3 }} size="small" colon>
                    <Descriptions.Item label="N° de police">{numeroPolice}</Descriptions.Item>
                    <Descriptions.Item label="Assuré">{assureNom}</Descriptions.Item>
                    <Descriptions.Item label="Immatriculation">{sinistre?.engin?.immatriculation || "-"}</Descriptions.Item>
                    <Descriptions.Item label="Évaluation normale">{fmt(sinistre?.evaluation)}</Descriptions.Item>
                    <Descriptions.Item label="Taux de responsabilité">
                        <Tag color={tauxResp >= 100 ? "red" : "blue"}>{tauxResp}%</Tag>
                    </Descriptions.Item>
                </Descriptions>
            </Card>
        </div>
    );

    const evaluationsTab = (
        <div style={{ padding: 4 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12, flexWrap: "wrap", gap: 8 }}>
                <Typography.Text type="secondary">
                    {recoursEvaluations?.length || 0} réévaluation(s) de recours
                </Typography.Text>
                <Button type="primary" icon={<ReloadOutlined />}
                    style={{ background: ACCENT, borderColor: ACCENT }}
                    onClick={() => {
                        // Ouvre le MÊME modal V2 que la réévaluation normale (piloté par le parent),
                        // en mode recours. Repli sur l'ancien flux si le callback n'est pas fourni.
                        if (onNouvelleReevaluation) {
                            onNouvelleReevaluation();
                        } else {
                            navigate('/evaluation-sinistre', { state: { recours: true, iz: sinistre?.codeId } });
                            setModalRecoursReevaluation(true);
                        }
                    }}>
                    Nouvelle réévaluation
                </Button>
            </div>

            {recoursEvaluations?.length ? (
                <List
                    grid={{ gutter: 12, xs: 1, sm: 1, md: 2, lg: 2, xl: 3 }}
                    dataSource={recoursEvaluations}
                    renderItem={(item) => {
                        const delta = (Number(item?.nouvelleProvision) || 0) - (Number(item?.ancienneProvision) || 0);
                        const hausse = delta >= 0;
                        return (
                            <List.Item>
                                <Card size="small" bordered style={{ borderRadius: 10, borderColor: "#2421661f" }}
                                    title={<span style={{ color: ACCENT }}>{item?.motifRevision || "Réévaluation"}</span>}
                                    extra={
                                        <Tooltip title="Modifier">
                                            <Button size="small" shape="circle" icon={<EditOutlined />} onClick={() => editEvaluation(item)} />
                                        </Tooltip>
                                    }>
                                    <Row justify="space-between" align="middle">
                                        <Col><Typography.Text type="secondary" style={{ fontSize: 12 }}>Ancienne</Typography.Text>
                                            <div>{fmt(item?.ancienneProvision)}</div></Col>
                                        <Col style={{ textAlign: "center" }}>
                                            <Tag color={hausse ? "green" : "red"} style={{ margin: 0 }}>
                                                {hausse ? <ArrowUpOutlined /> : <ArrowDownOutlined />} {fmt(Math.abs(delta))}
                                            </Tag>
                                        </Col>
                                        <Col style={{ textAlign: "right" }}><Typography.Text type="secondary" style={{ fontSize: 12 }}>Nouvelle</Typography.Text>
                                            <div style={{ fontWeight: 700, color: ACCENT }}>{fmt(item?.nouvelleProvision)}</div></Col>
                                    </Row>
                                    <Divider style={{ margin: "10px 0" }} />
                                    <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                                        Réévaluée le {frenchDate(item?.createdAt)}
                                    </Typography.Text>
                                </Card>
                            </List.Item>
                        );
                    }}
                />
            ) : (
                <Empty description="Aucune réévaluation de recours sur ce dossier" />
            )}
        </div>
    );

    const encaissementsTab = (
        <div style={{ padding: 4 }}>
            {!hasEvalRecours && (
                <Alert
                    type="warning"
                    showIcon
                    style={{ marginBottom: 12, borderRadius: 8 }}
                    message="Aucune évaluation de recours sur ce dossier"
                    description="Sans évaluation de recours, aucun encaissement de recours n'est possible. Évaluez d'abord le recours (onglet « Évaluations »)."
                />
            )}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12, flexWrap: "wrap", gap: 8 }}>
                <Space size="large" wrap>
                    <Typography.Text type="secondary">
                        {encaissements?.length || 0} encaissement(s) de recours
                    </Typography.Text>
                    {/* SAP recours = reste à encaisser (toujours visible ici, au plus près de l'action). */}
                    <Typography.Text style={{ color: "#d46b08" }}>
                        Reste à encaisser (SAP recours) : <b>{fmt(sapRecoursVal)}</b>
                    </Typography.Text>
                </Space>
                <Tooltip title={hasEvalRecours ? "" : "Évaluez d'abord le recours pour pouvoir encaisser."}>
                    <Button type="primary" icon={<PlusOutlined />}
                        disabled={!hasEvalRecours}
                        style={hasEvalRecours ? { background: ACCENT, borderColor: ACCENT } : undefined}
                        onClick={() => setReglementModalOpen(true)}>
                        Nouvel encaissement
                    </Button>
                </Tooltip>
            </div>

            {/* Encaissements en TABLEAU, sur le modèle de la liste des règlements. */}
            <Table
                size="small"
                rowKey={(r) => r?.codeId || r?.decaissementId}
                dataSource={encaissements || []}
                pagination={encaissements?.length > 10 ? { pageSize: 10, showSizeChanger: true } : false}
                scroll={{ x: 720 }}
                locale={{ emptyText: <Empty description="Aucun encaissement de recours sur ce dossier" /> }}
                columns={[
                    {
                        title: "Bénéficiaire",
                        key: "beneficiaire",
                        render: (_, r) => {
                            const b = r?.beneficiaire;
                            const nom = b ? `${b.nom || ""} ${b.prenom || ""}`.trim() : "";
                            return nom || r?.beneficiaireMoral?.nom || r?.beneficiaireConstat?.nom || "—";
                        },
                    },
                    {
                        title: "Chèque",
                        dataIndex: "numeroCheque",
                        width: 110,
                        render: (n) => n ? <Tag color="blue">{n}</Tag> : <Tag>—</Tag>,
                    },
                    {
                        title: "Montant TTC",
                        dataIndex: "montantGlobal",
                        align: "right",
                        render: (v) => <Typography.Text strong>{fmt(v)}</Typography.Text>,
                    },
                    {
                        title: "Montant retenu",
                        key: "retenu",
                        align: "right",
                        render: (_, r) => fmt(r?.montantPaye ? (Number(r?.montantGlobal) || 0) - (Number(r?.montantPaye) || 0) : 0),
                    },
                    {
                        title: "Date",
                        dataIndex: "dateReglement",
                        width: 120,
                        render: (d) => d ? frenchDate(d) : "—",
                    },
                    {
                        title: "Actions",
                        key: "actions",
                        width: 90,
                        align: "center",
                        render: (_, r) => (!r?.numeroCheque
                            ? <Tooltip title="Assigner un chèque">
                                <Button size="small" type="primary" ghost icon={<CreditCardOutlined />}
                                    onClick={() => { setEncaissement(r); setModalAssignCheque(true); }} />
                            </Tooltip>
                            : <Tag color="green">Assigné</Tag>),
                    },
                ]}
                summary={(rows) => {
                    const total = (rows || []).reduce((a, d) => a + (Number(d?.montantGlobal) || 0), 0);
                    return (
                        <Table.Summary.Row>
                            <Table.Summary.Cell index={0} colSpan={2}><b>Total encaissé</b></Table.Summary.Cell>
                            <Table.Summary.Cell index={1} align="right"><b>{fmt(total)}</b></Table.Summary.Cell>
                            <Table.Summary.Cell index={2} colSpan={3} />
                        </Table.Summary.Row>
                    );
                }}
            />

            <ReglementRecoursModal sinistre={sinistre} modalControl={reglementControl} />
            <AssignCheque
                open={modalAssignCheque}
                decaissement={encaissement}
                sinistre={sinistre}
                onCancel={() => setModalAssignCheque(false)}
                onSuccess={() => { setModalAssignCheque(false); reloadDossier(); }}
            />
        </div>
    );

    return (
        <>
            <Card style={{ borderRadius: 12 }}>
                <Spin spinning={loadingSinistre}>
                    <Tabs
                        onChange={onTabsChange}
                        activeKey={tabId}
                        items={[
                            { key: "1", label: "Résumé", children: resumeTab },
                            { key: "2", label: `Évaluations (${recoursEvaluations?.length || 0})`, children: evaluationsTab },
                            { key: "3", label: `Encaissements (${encaissements?.length || 0})`, children: encaissementsTab },
                        ]}
                    />
                </Spin>
                <Modal
                    title={
                        editMode
                            ? "MISE À JOUR RÉEVALUATION - RECOURS"
                            : "REÉVALUATION - RECOURS"
                    }
                    centered
                    open={modalRecoursReevaluation}
                    onOk={(e) => {
                        setIsRecours(true);
                        handleSubmit(e, true);
                    }}
                    onCancel={() => {
                        setEvaluation(initEvaluation);
                        setModalRecoursReevaluation(false);
                    }}
                >
                    <Card>
                        <CardBody>
                            <div className={'container'} style={{ justifyContent: 'center' }}>
                                <div className={'grid-item'}>
                                    <div>
                                        <b>Ancienne provision :</b>{" "}
                                        <Tag color="blue">
                                            <b>
                                                {sinistre?.evaluation
                                                    ? displayNumbers(
                                                        sinistre?.evaluation
                                                    )
                                                    : "0"}{" "}
                                                FCFA
                                            </b>
                                        </Tag>
                                    </div>
                                    <br />

                                    <div className={'container'} style={{ justifyContent: 'center' }}>
                                        <div className={'grid-item'}>
                                            <div className={'form-control'}
                                            >
                                                <Select
                                                    mode="multiple"
                                                    className={'select2'}
                                                    /*MenuProps={{
                                                        className: selectClasses.selectMenu,
                                                    }}*/
                                                    /* classes={{
                                                         select: selectClasses.select,
                                                     }}*/
                                                    value={valueSelected}
                                                    onChange={(value) => {
                                                        let vs = valueSelected;
                                                        if (value.length > vs.length) {
                                                            addProvisionFormFields();
                                                        } else {
                                                            let outGarantie = value.filter(
                                                                (v) => !garanties.includes(v)
                                                            );
                                                            // console.log(outGarantie);

                                                            outGarantie &&
                                                                removeProvisionFormFields(
                                                                    outGarantie[0]
                                                                );
                                                        }
                                                        const gs = [];
                                                        value.forEach((v) => {
                                                            let g = garanties.find(
                                                                (gar) => gar.value === v
                                                            );
                                                            g && gs.push(g.garantie);
                                                        });
                                                        setValueSelected(value);
                                                        setSelectedGaranties(gs);
                                                        // console.log("Target...", value);
                                                        value.length
                                                            ? setGarantieState("success")
                                                            : setGarantieState("error");
                                                    }}
                                                    options={garanties}
                                                    placeholder="Sélectionnez des garanties"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {selectedGaranties.length ? (
                                        <div className={'container'} style={{ justifyContent: 'center' }}>
                                            {selectedGaranties.map((sg, index) => (
                                                <div className={'grid-item'}
                                                    key={index}
                                                >
                                                    <label
                                                        htmlFor="capital"
                                                        style={{
                                                            margin: "30px 0 10px 0",
                                                        }}
                                                    >
                                                        Provision Garantie {sg.nom} :
                                                    </label>
                                                    <Input
                                                        id="capital"
                                                        name="capital"
                                                        placeholder="Veuillez entrer la valeur de la provision"
                                                        value={
                                                            provisionGaranties[index].provision
                                                        }
                                                        onChange={(event) => {
                                                            let newProvisionFormFields = [
                                                                ...provisionGaranties,
                                                            ];
                                                            newProvisionFormFields[
                                                                index
                                                            ].garantie = sg;
                                                            newProvisionFormFields[
                                                                index
                                                            ].provision = event.target.value;
                                                            setProvisionGarantie(
                                                                newProvisionFormFields
                                                            );
                                                        }}
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    ) : null}
                                    <br />
                                    <div>
                                        <b>Nouvelle provision :</b>{" "}
                                        <Tag color="green">
                                            <b>
                                                {evaluation?.nouvelleProvision
                                                    ? displayNumbers(
                                                        evaluation?.nouvelleProvision
                                                    )
                                                    : "0"}{" "}
                                                FCFA
                                            </b>
                                        </Tag>
                                    </div>

                                    <br />
                                    <div className={'form-control'}
                                    >
                                        <Select
                                            id="motifRevision"
                                            name="motifRevision"
                                            placeholder="Motif de la révision"
                                            dropdownRender={(menu) => (
                                                <>
                                                    {menu}
                                                    <Divider
                                                        style={{
                                                            margin: "8px 0",
                                                        }}
                                                    />
                                                    <Space
                                                        style={{
                                                            padding: "0 8px 4px",
                                                        }}
                                                    >
                                                        <Input
                                                            placeholder="Ajouter un motif"
                                                            ref={inputRef}
                                                            value={name}
                                                            onChange={onNameChange}
                                                        />
                                                        <Button
                                                            type="text"
                                                            icon={<PlusOutlined />}
                                                            onClick={addItem}
                                                        >
                                                            Ajouter un motif
                                                        </Button>
                                                    </Space>
                                                </>
                                            )}
                                            options={items.map((item) => ({
                                                label: item,
                                                value: item,
                                            }))}
                                            onChange={(value) => {
                                                handleChange(value, "motifRevision");
                                                console.log(value);
                                                if (value.trim().length > 3) {
                                                    setMotifRevisionState("success");
                                                } else {
                                                    setMotifRevisionState("error");
                                                }
                                            }}
                                            value={evaluation.motifRevision}
                                        />
                                    </div>
                                    <br />
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </Modal>
                <Modal
                    title="Clôture du dossier sinistre"
                    open={modalCloture}
                    onOk={() => handleClotureDossier()}
                    confirmLoading={loadingCloture}
                    onCancel={() => setModalCloture(false)}
                >
                    <p>Voulez-vous vraiment clôturer ce dossier sinistre?</p>
                </Modal>
                <Modal
                    title="Suspension du dossier sinistre"
                    open={modalSuspension}
                    onOk={() => handleSuspensionDossier()}
                    confirmLoading={loadingSuspension}
                    onCancel={() => setModalSuspension(false)}
                >
                    <p>
                        Voulez-vous vraiment classer le dossier {"'"}Sans suite
                        {"'"}?
                    </p>
                </Modal>
                <Encaissement
                    open={modalEncaissement}
                    setOpenEncaissement={setOpenEncaissement}
                />
            </Card>

        </>
    )
}

export default Recours;
